// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#map {
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.bs-zoom-control {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    width: 2.2rem;
}

.bs-zoom-control span {
    width: 100%;
}

.bs-zoom-control input {
    padding: 5px 2px;
    pointer-events: none;
    opacity: 1 !important;
}

.bs-zoom-control button.p-inputnumber-button-up {
    padding: 8px 0px;
    border-radius: 2px 2px 0 0;
    background-color: var(--bs-color);
    border-color: var(--bs-color);
}

.bs-zoom-control button.p-inputnumber-button-down {
    padding: 8px 0px;
    border-radius: 0 0 2px 2px;
    background-color: var(--bs-color);
    border-color: var(--bs-color);
}

#modify-feature-measure {
    background: var(--bs-color);
    color: white;
    padding: 5px;
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

#wfs_modify_action_buttons {
    display: none;
    position: absolute;
    margin-left: 40px;
    text-align: center;
    align-items: center;
    justify-items: center;
    flex-direction: column;

    .info-selected-layer {
        width: 100%;
        background: #fff;
        box-shadow: 0 0 10px #828282;
        margin-top: 5px;
        padding: 5px;
        border-radius: 3px;
        font-weight: 600;
        display: flex;
        min-width: 7rem;
        justify-content: center;
    }
}

.ol-rotate {
    position: absolute;
    left: auto !important;
    right: 9rem !important;
    top: auto !important;
    bottom: 0.5rem !important;

}

.ol-rotate .pi-send {
    font-size: 2rem !important;
}

.rotate-north {
    top: 65px;
    left: .5em;
}

.ol-touch .rotate-north {
    top: 80px;
}

.ol-zoom {
    display: none;
}

.ol-rotate-reset {
    background: none !important;
    border: none !important;
}

.p-button-custom {

    margin: var(--bs-tool-menu-margin);
    color: #fff;
    background: var(--bs-color);
    width: 2rem;
    height: 2rem;
    font-size: 1.3rem;
    border-radius: 1px;
    padding: 0;
}

.ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;

    #popup-content {
        display: flex;
        margin-top: 5px;

        .info-div {
            width: max-content;
            display: flex;
            flex-direction: row;

            >div {
                display: flex;
                flex-direction: column;

                b {
                    border-bottom: 1px solid #ddd;
                }

                .left-side {
                    background: #efefef !important;
                    padding: 1px 5px;
                }

                .right-side {
                    background: white;
                    padding: 1px 5px;
                    font-weight: 400;
                    color: var(--bs-color);
                }
            }
        }
    }

}

.ol-popup:after,
.ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
}

.ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
}

.ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 2px;
    right: 8px;
    color: #ef4444;
    font-size: 16px;
}

.ol-popup-closer:after {
    content: "✖";
}

.custom-rotation-buttons {
    position: inherit;
    right: 2rem;
}

.bs-zoom-control .custom-rotation-buttons .button .p-inputnumber-button-up {
    padding: 8px 8px !important;
    border-radius: 4px !important;
}

.custom-rotation-buttons button.p-inputnumber-button-down {
    margin-top: 32px !important;
    border-radius: 4px !important;
}

.bs-zoom-control .custom-rotation-buttons input {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/Map.scss"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;;IAEtB;QACI,WAAW;QACX,gBAAgB;QAChB,4BAA4B;QAC5B,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,aAAa;QACb,eAAe;QACf,uBAAuB;IAC3B;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,yBAAyB;;AAE7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;;IAEI,kCAAkC;IAClC,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,WAAW;;IAEX;QACI,aAAa;QACb,eAAe;;QAEf;YACI,kBAAkB;YAClB,aAAa;YACb,mBAAmB;;YAEnB;gBACI,aAAa;gBACb,sBAAsB;;gBAEtB;oBACI,6BAA6B;gBACjC;;gBAEA;oBACI,8BAA8B;oBAC9B,gBAAgB;gBACpB;;gBAEA;oBACI,iBAAiB;oBACjB,gBAAgB;oBAChB,gBAAgB;oBAChB,sBAAsB;gBAC1B;YACJ;QACJ;IACJ;;AAEJ;;AAEA;;IAEI,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB","sourcesContent":["#map {\r\n    height: 100vh;\r\n    width: 100%;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n}\r\n\r\n.bs-zoom-control {\r\n    position: absolute;\r\n    right: 1rem;\r\n    bottom: 1rem;\r\n    width: 2.2rem;\r\n}\r\n\r\n.bs-zoom-control span {\r\n    width: 100%;\r\n}\r\n\r\n.bs-zoom-control input {\r\n    padding: 5px 2px;\r\n    pointer-events: none;\r\n    opacity: 1 !important;\r\n}\r\n\r\n.bs-zoom-control button.p-inputnumber-button-up {\r\n    padding: 8px 0px;\r\n    border-radius: 2px 2px 0 0;\r\n    background-color: var(--bs-color);\r\n    border-color: var(--bs-color);\r\n}\r\n\r\n.bs-zoom-control button.p-inputnumber-button-down {\r\n    padding: 8px 0px;\r\n    border-radius: 0 0 2px 2px;\r\n    background-color: var(--bs-color);\r\n    border-color: var(--bs-color);\r\n}\r\n\r\n#modify-feature-measure {\r\n    background: var(--bs-color);\r\n    color: white;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\r\n}\r\n\r\n#wfs_modify_action_buttons {\r\n    display: none;\r\n    position: absolute;\r\n    margin-left: 40px;\r\n    text-align: center;\r\n    align-items: center;\r\n    justify-items: center;\r\n    flex-direction: column;\r\n\r\n    .info-selected-layer {\r\n        width: 100%;\r\n        background: #fff;\r\n        box-shadow: 0 0 10px #828282;\r\n        margin-top: 5px;\r\n        padding: 5px;\r\n        border-radius: 3px;\r\n        font-weight: 600;\r\n        display: flex;\r\n        min-width: 7rem;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.ol-rotate {\r\n    position: absolute;\r\n    left: auto !important;\r\n    right: 9rem !important;\r\n    top: auto !important;\r\n    bottom: 0.5rem !important;\r\n\r\n}\r\n\r\n.ol-rotate .pi-send {\r\n    font-size: 2rem !important;\r\n}\r\n\r\n.rotate-north {\r\n    top: 65px;\r\n    left: .5em;\r\n}\r\n\r\n.ol-touch .rotate-north {\r\n    top: 80px;\r\n}\r\n\r\n.ol-zoom {\r\n    display: none;\r\n}\r\n\r\n.ol-rotate-reset {\r\n    background: none !important;\r\n    border: none !important;\r\n}\r\n\r\n.p-button-custom {\r\n\r\n    margin: var(--bs-tool-menu-margin);\r\n    color: #fff;\r\n    background: var(--bs-color);\r\n    width: 2rem;\r\n    height: 2rem;\r\n    font-size: 1.3rem;\r\n    border-radius: 1px;\r\n    padding: 0;\r\n}\r\n\r\n.ol-popup {\r\n    position: absolute;\r\n    background-color: white;\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    border: 1px solid #cccccc;\r\n    bottom: 12px;\r\n    left: -50px;\r\n\r\n    #popup-content {\r\n        display: flex;\r\n        margin-top: 5px;\r\n\r\n        .info-div {\r\n            width: max-content;\r\n            display: flex;\r\n            flex-direction: row;\r\n\r\n            >div {\r\n                display: flex;\r\n                flex-direction: column;\r\n\r\n                b {\r\n                    border-bottom: 1px solid #ddd;\r\n                }\r\n\r\n                .left-side {\r\n                    background: #efefef !important;\r\n                    padding: 1px 5px;\r\n                }\r\n\r\n                .right-side {\r\n                    background: white;\r\n                    padding: 1px 5px;\r\n                    font-weight: 400;\r\n                    color: var(--bs-color);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.ol-popup:after,\r\n.ol-popup:before {\r\n    top: 100%;\r\n    border: solid transparent;\r\n    content: \" \";\r\n    height: 0;\r\n    width: 0;\r\n    position: absolute;\r\n    pointer-events: none;\r\n}\r\n\r\n.ol-popup:after {\r\n    border-top-color: white;\r\n    border-width: 10px;\r\n    left: 48px;\r\n    margin-left: -10px;\r\n}\r\n\r\n.ol-popup:before {\r\n    border-top-color: #cccccc;\r\n    border-width: 11px;\r\n    left: 48px;\r\n    margin-left: -11px;\r\n}\r\n\r\n.ol-popup-closer {\r\n    text-decoration: none;\r\n    position: absolute;\r\n    top: 2px;\r\n    right: 8px;\r\n    color: #ef4444;\r\n    font-size: 16px;\r\n}\r\n\r\n.ol-popup-closer:after {\r\n    content: \"✖\";\r\n}\r\n\r\n.custom-rotation-buttons {\r\n    position: inherit;\r\n    right: 2rem;\r\n}\r\n\r\n.bs-zoom-control .custom-rotation-buttons .button .p-inputnumber-button-up {\r\n    padding: 8px 8px !important;\r\n    border-radius: 4px !important;\r\n}\r\n\r\n.custom-rotation-buttons button.p-inputnumber-button-down {\r\n    margin-top: 32px !important;\r\n    border-radius: 4px !important;\r\n}\r\n\r\n.bs-zoom-control .custom-rotation-buttons input {\r\n    display: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
